<template>
  <div>
    <collapse title="Información de la Solicitud">
      <div class="row">
        <div class="col-4">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-date-picker
              v-model="date"
              class="w-100 custom-date-picker"
              :clearable="false"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Fecha:"
              :max-date="new Date()"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
          <label v-else-if="isReadOnly">
            {{ date | date }}
          </label>
        </div>
      </div>
      <div v-if="isAmendmentRenewal" class="row mt-3">
        <div class="col">
          <label class="data-label">
            ¿La Solicitud de Compra del servicio se realizó a través de MIPE?
          </label>
          <validation-provider v-slot="{ validated }" rules="required">
            <custom-radio
              v-model="isFromMipe"
              class="custom-radio"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              is-inline
              name="isFromMipe"
              :options="yesNoOptions"
              @input="onIsFromMipeChange"
            />
            <error
              v-if="validated && ![true, false].includes(isFromMipe?.value)"
              message="El campo es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
      </div>
      <div
        v-if="isFromMipe?.value && isAmendmentRenewal"
        class="mt-3 bg-white rounded pb-3"
      >
        <validation-observer ref="requestFormMipe">
          <div v-if="!isReadOnly" class="row m-1 py-3">
            <div class="col">
              <validation-provider
                v-if="!isReadOnly"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-input
                  v-model="requestNumber"
                  custom-error-msg="El campo es requerido."
                  :disabled="requestChecked"
                  :error="errors[0]"
                  icon="fal fa-search color-primary-2"
                  left-icon
                  placeholder="Número o Nombre de Compra de Servicio"
                  prepend-icon-type="success"
                />
              </validation-provider>
            </div>
            <div class="col-auto">
              <action-button
                :disabled="requestChecked"
                i="fal fa-search"
                text="Buscar"
                variant="success px-3"
                @click="searchRequest"
              />
            </div>
          </div>

          <custom-separator v-if="!isReadOnly" class="my-2" text="Resultados" />
          <custom-callout
            v-if="previousRequest"
            :border-color="'#B5C3BC'"
            class="mx-3 pt-3"
            :has-toggle="false"
          >
            <div class="row m-1 py-2">
              <div class="col-11">
                <span class="body-2 text-gray">
                  Número de Compra de Servicio
                </span>
                <div :class="`body-1 font-16 color-black`">
                  {{ previousRequest }}
                </div>
              </div>
              <div v-if="!isReadOnly" class="col-1">
                <div :class="`body-1 font-16 color-black`">
                  <check-box
                    v-model="requestChecked"
                    class="align-self-center mt-3"
                    @input="onChangeRequestCheck"
                  />
                </div>
              </div>
            </div>
          </custom-callout>
          <!-- alerta -->
          <div
            v-if="warningMessage"
            class="alert alert-warning m-3"
            role="alert"
          >
            <i class="fas fa-bell mr-2" />
            <span>{{ warningMessage }}</span>

            <span
              v-if="
                suggestedRequestNumber &&
                  suggestedRequestNumber !== requestNumber
              "
              class=" btn-link p-0 ml-1"
              type="button"
              @click="onClickSuggestedNumber"
            >
              {{ suggestedRequestNumber }}
            </span>
          </div>
        </validation-observer>
      </div>
      <div v-if="isFromMipe?.value === false && isAmendmentRenewal">
        <validation-observer ref="requestFormMipe">
          <div class="row py-3">
            <div class="col-md-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.parentNumber"
                  custom-error-msg="El campo es requerido."
                  :disabled="isReadOnly"
                  :error="errors[0]"
                  label="Número de PSF:"
                />
              </validation-provider>
            </div>
          </div>
        </validation-observer>
      </div>

      <div v-if="isAmendmentRenewal" class="row mt-3">
        <div class="col">
          <label class="data-label">
            ¿El proceso de competencia se realizó a través de MIPE?
          </label>
          <validation-provider v-slot="{ validated }" rules="required">
            <custom-radio
              v-model="isCompetitionProcessFromMipe"
              class="custom-radio"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              is-inline
              name="isCompetitionProcessFromMipe"
              :options="yesNoOptions"
              @input="isCompetitionProcessFromMipeChange"
            />
            <error
              v-if="
                validated &&
                  ![true, false].includes(isCompetitionProcessFromMipe?.value)
              "
              message="El campo es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
      </div>
      <div
        v-if="isCompetitionProcessFromMipe?.value && isAmendmentRenewal"
        class="mt-3 bg-white rounded pb-3"
      >
        <validation-observer ref="competitionProcessFormMipe">
          <div v-if="!isReadOnly" class="row m-1 py-3">
            <div class="col">
              <validation-provider
                v-if="!isReadOnly"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-input
                  v-model="announcementNumber"
                  custom-error-msg="El campo es requerido."
                  :disabled="competitionRequestChecked"
                  :error="errors[0]"
                  icon="fal fa-search color-primary-2"
                  left-icon
                  placeholder="Escriba Número de Pliego"
                  prepend-icon-type="success"
                />
              </validation-provider>
            </div>
            <div class="col-auto">
              <action-button
                :disabled="competitionRequestChecked"
                i="fal fa-search"
                text="Buscar"
                variant="success px-3"
                @click="searchAnnouncement"
              />
            </div>
          </div>

          <custom-separator v-if="!isReadOnly" class="my-2" text="Resultados" />
          <custom-callout
            v-if="previousAnnouncementNumber"
            :border-color="'#B5C3BC'"
            class="mx-3 pt-3"
            :has-toggle="false"
          >
            <div class="row m-1 py-2">
              <div class="col-11">
                <span class="body-2 text-gray">
                  Número de Pliego
                </span>
                <div :class="`body-1 font-16 color-black`">
                  {{ previousAnnouncementNumber }}
                </div>
              </div>
              <div v-if="!isReadOnly" class="col-1">
                <div :class="`body-1 font-16 color-black`">
                  <check-box
                    v-model="competitionRequestChecked"
                    class="align-self-center mt-3"
                    @input="onChangeCompetitionRequestCheck"
                  />
                </div>
              </div>
            </div>
          </custom-callout>
        </validation-observer>
      </div>
    </collapse>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomRadio from 'custom-radio';
import CustomInput from 'CustomInput';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import Error from 'custom-error';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomCallout from 'custom-callout';
import {
  getByNumber,
  getAnnouncementByNumber,
} from '@/modules/purchaseService/api.js';
import alertMixin from '@/mixins/alert.mixin.js';

export default {
  name: 'PurchaseServiceRequestInformation',
  components: {
    Collapse,
    ValidationProvider,
    CustomInput,
    CustomRadio,
    Error,
    CustomDatePicker,
    ActionButton,
    CustomSeparator,
    CustomCallout,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isAmendmentRenewal: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      requestNumber: null,
      requestChecked: null,
      previousRequest: null,
      announcementNumber: null,
      competitionRequestChecked: null,
      previousAnnouncementNumber: null,
      previousAnnouncementId: null,
      warningMessage: null,
      suggestedRequestNumber: null,
      autoCompleteFromPurchaseService: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value?.detail;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    date: {
      get() {
        return this.value?.date;
      },
      set(value) {
        this.$emit('input', {
          ...this.value,
          date: value,
        });
      },
    },
    isFromMipe: {
      get() {
        const value = this.yesNoOptions.find(
          (x) => x.value === this.value.detail?.isFromMipe
        );

        return value ?? {};
      },
      set(option) {
        this.model.isFromMipe = option?.value;
      },
    },
    isCompetitionProcessFromMipe: {
      get() {
        const value = this.yesNoOptions.find(
          (x) => x.value === this.value.detail?.isCompetitionProcessFromMipe
        );

        return value ?? {};
      },
      set(option) {
        this.model.isCompetitionProcessFromMipe = option?.value;
      },
    },
    yesNoOptions() {
      return [
        {
          id: 1,
          name: 'yes',
          label: 'Si',
          value: true,
        },
        {
          id: 2,
          name: 'no',
          label: 'No',
          value: false,
        },
      ];
    },
  },
  watch: {
    'model.parentNumber': {
      immediate: true,
      handler(val, old) {
        if (val == undefined || val == null) {
          this.requestNumber = null;
          this.previousRequest = null;
        } else if (val != old) {
          this.requestNumber = val;
          this.previousRequest = val;
          this.requestChecked = true;
        }
      },
    },
    'model.announcementNumber': {
      immediate: true,
      handler(val, old) {
        if (val == undefined || val == null) {
          this.announcementNumber = null;
          this.previousAnnouncementNumber = null;
        } else if (val != old) {
          this.announcementNumber = val;
          this.previousAnnouncementNumber = val;
          this.competitionRequestChecked = true;
        }
      },
    },
  },
  methods: {
    async searchRequest() {
      const formOk = await this.$refs.requestFormMipe.validate();
      if (!formOk) {
        this.ShowToast(
          '',
          'Debe tener completado el número de compra de servicio',
          'error'
        );
        return;
      }

      this.warningMessage = null;
      this.suggestedRequestNumber = null;

      const { data } = await getByNumber(this.id, this.requestNumber);

      if (!data) {
        this.previousRequest = null;
        this.$emit('search', null);
        this.ShowToast(
          '',
          'Número de Compra de Servicio no encontrado.',
          'error'
        );
        return;
      }

      if (data.warningMessage) {
        this.warningMessage = data.warningMessage;
        this.suggestedRequestNumber = data.suggestedNumber || null;
      }

      if (!data.purchaseService) {
        this.previousRequest = null;
        this.$emit('search', null);
        return;
      }

      this.previousRequest = data.purchaseService.number;

      if (data.purchaseService.announcementNumber) {
        this.autoCompleteFromPurchaseService = true;
        this.announcementNumber = data.purchaseService.announcementNumber;
      }

      this.$emit('search', data.purchaseService);
    },

    async onClickSuggestedNumber() {
      if (!this.suggestedRequestNumber) return;

      this.requestNumber = this.suggestedRequestNumber;

      this.warningMessage = null;
      this.suggestedRequestNumber = null;

      await this.searchRequest();
    },
    async searchAnnouncement(autoComplete = false) {
      this.autoCompleteFromPurchaseService = autoComplete;

      const formOk = await this.$refs.competitionProcessFormMipe.validate();
      if (!formOk) {
        this.ShowToast(
          '',
          'Debe tener completado el número de compra de servicio',
          'error'
        );
        return;
      }

      const { data } = await getAnnouncementByNumber(
        this.id,
        this.announcementNumber
      );

      this.previousAnnouncementNumber = data.name;
      this.previousAnnouncementId = data.id;

      if (!data) {
        this.ShowToast('', 'Número de pliego no encontrado.', 'error');
        return;
      }

      if (this.autoCompleteFromPurchaseService) {
        this.competitionRequestChecked = true;
        await this.onChangeCompetitionRequestCheck(true);
      }
    },
    async onChangeRequestCheck() {
      this.model.parentNumber = this.previousRequest;

      if (this.autoCompleteFromPurchaseService) {
        this.isCompetitionProcessFromMipe = this.yesNoOptions.find(
          (x) => x.value === true
        );

        await new Promise((resolve) => setTimeout(resolve, 500));
        await this.searchAnnouncement(true);
      }
    },
    async onChangeCompetitionRequestCheck(value) {
      this.model.announcementNumber = this.previousAnnouncementNumber;

      if (this.previousAnnouncementId && value) {
        const payload = {
          announcementId: this.previousAnnouncementId,
          isCompetitionProcessFromMipe: value,
        };
        this.$emit('contractors', payload);
      }
    },
    onIsFromMipeChange() {
      this.requestNumber = null;
      this.requestChecked = null;
      this.previousRequest = null;
      this.model.parentNumber = null;
      this.warningMessage = null;
      this.suggestedRequestNumber = null;
    },
    isCompetitionProcessFromMipeChange({ value }) {
      this.announcementNumber = null;
      this.competitionRequestChecked = null;
      this.previousAnnouncementNumber = null;
      this.model.announcementNumber = null;
      this.$emit('reset-contractors', value);
    },
  },
};
</script>
<style scoped>
.custom-radio ::v-deep .col-12 {
  padding: 0 !important;
}
.custom-font {
  color: #727272;
  font-size: 14px;
}
::v-deep .custom-datetime-picker-container {
  width: 100% !important;
  input[type='text'] {
    width: 100%;
  }
}
</style>
